import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {EmpresaService} from '../../services/empresa.service';

@Component({
  selector: 'app-form-integracao-ifood-centralizado',
  templateUrl: './form-integracao-ifood-centralizado.component.html',
  styleUrls: ['./form-integracao-ifood-centralizado.component.scss']
})
export class FormIntegracaoIfoodCentralizadoComponent {
  @ViewChild('frm', {}) frm: any;
  @Input() empresa: any;
  @Input() integracaoIfood: any = {};
  @Output() salvou = new EventEmitter<any>();
  @Output() cancelou = new EventEmitter<void>();
  mensagemErro: string;
  salvando = false;

  constructor(private empresaService: EmpresaService) { }

  async onSubmit(): Promise<void> {
    if(!this.frm.valid) return;

    if(!this.catalogApiAtiva())
      this.integracaoIfood.publicacaoCatalogoHabilitada = false;

    this.salvando = true;
    this.mensagemErro = null;
    try {
      const integracao = await this.empresaService.atualizeIntegracaoIfood(this.integracaoIfood);
      this.salvou.emit(integracao);
    } catch(erro) {
      this.mensagemErro = String(erro?.message || erro || 'Não foi possível salvar a integração.');
    } finally {
      this.salvando = false;
    }
  }

  cancelar(): void {
    this.cancelou.emit();
  }

  catalogApiAtiva(): boolean {
    return this.integracaoIfood != null && this.integracaoIfood.desativado !== true;
  }
}
